export default __webpack_public_path__ + "d748f0d9f64c0ca1a40a0f6ec6bbb746.svg";